import './radioButton.scss';
import type {RadioButton_Icon_Props} from "./RadioButton.interface";
import {Icon} from "../../Basic/Icon";
import {Paragraph} from "../../Elements/Paragraph";
import {useTranslation} from "react-i18next";

/**
 * Primary UI component for user interaction
 */
export function IconRadioButton (props: RadioButton_Icon_Props) {
    
    const {t} = useTranslation();
    
    return (
        <div className={["radiobutton-wrapper", props.className, props.hide ? "hide" : "", props.recommended ? "highlight" : "no-highlight"].join(" ")}>
            {props.recommended &&
            <div className={"recommended"} onClick={props.disabled ? () => {} : props.onClick}>
                {t("button.recommended")}
            </div>
            }
            <div className="radiobutton-input-row" onClick={props.disabled ? () => {} : props.onClick}>
                <div className="input">
                    <input id={props.id}
                           aria-label={props.id}
                           type="radio"
                           readOnly
                           disabled={props.disabled}
                           checked={props.disabled ? false : props.selected}
                    />
                </div>
                <div className={["image", props.disabled ? "disabled" : ""].join(" ")}>
                    <Icon icon={props.icon}/>
                </div>
                <div className={props.disabled ? "disabled" : ""}>
                    <label htmlFor={props.id} aria-label={props.id}>
                        {props.label} <span className={[props.disabled ? "disabled font-weight-normal" : ""].join(" ")}>{props.labelNote}</span>
                    </label>
                </div>
            </div>
            {props.selected &&
                <div className="radiobutton-content-row">
                    <div className="text">
                        <Paragraph text={props.text}/>
                    </div>
                </div>
            }
        </div>
    );
}
